<template>
    <v-btn
      density="default"
      class="product-pad__button text-white mx-1 mx-sm-3 mb-1"
      rounded="xl"
      :style="$vuetify.display.xs ? 'height: 30px; font-size: 0.5em;' : ''"
      :size="displaySize"
      :color="isActive ? '#005686' : '#7CA3BB'"
      @click="handleClick($event)"
    >{{ title }}
    </v-btn>
</template>
<script>
    export default {
        name: 'ProductsPadButton',

        props: {
            title: String,
            id: String,
            isActive: Boolean
        },

        emits: ['buttonClicked', 'loadModel'],
        computed: {
            displaySize () {
                if(this.$vuetify.display.smAndDown) return 'x-small'
                return 'small'
            }
        },
        methods: {
            handleClick(){
                this.$emit('buttonClicked', this.id)
                this.$emit('loadModel', this.id)
        }
    }
}
</script>
